import React from "react";
import { Link } from 'react-router-dom';
import BusinessFinderImage from "../../img/business-finder.png";
import Datapoint from "../Datapoint";
import Footer from "../Footer";

const LandingPage = ({ signUpEmail, setSignUpEmail }) => {
  const handleEmailChange = e => setSignUpEmail(e.target.value);

  return (
    <div className="landing-page">

      {/* HERO */}
      <section className="hero">
        <h1 className="hero-text">
          Endless B2B Leads. Zero Guesswork.
        </h1>
        <p className="sub-hero-text">
          Instantly uncover verified emails & phone numbers in any industry—so you can fill your pipeline and close deals with confidence.
        </p>
        <div className="hero-cta">
          <input
            type="email"
            value={signUpEmail}
            onChange={handleEmailChange}
            placeholder="Enter your best email"
          />
          <Link to="/signup"><button className="btn-primary">
            Start Your Free Trial
          </button></Link>
        </div>
        <img
          className="hero-image"
          src={BusinessFinderImage}
          alt="Lead finder dashboard preview"
        />
      </section>

      {/* HOW IT WORKS */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps">
          <div className="step">
            <h3>1. Define Your Ideal Prospect</h3>
            <p>Filter by industry, location, company size, tech stack, and more—pinpoint exactly who you need to reach.</p>
          </div>
          <div className="step">
            <h3>2. Generate & Export</h3>
            <p>Click “Generate” to instantly see thousands of verified contacts. Export with one click or sync to your CRM.</p>
          </div>
          <div className="step">
            <h3>3. Engage & Convert</h3>
            <p>Launch targeted email and call campaigns with confidence, backed by 99% accurate data.</p>
          </div>
        </div>
      </section>

      {/* FEATURES & DATA */}
      <section className="features">
        <h2>Built for Sales Success</h2>
        <ul className="feature-list">
          <li>✅ AI-powered prospect recommendations</li>
          <li>✅ Unlimited list exports</li>
          <li>✅ One-click CRM integration</li>
          <li>✅ Real-time data refresh</li>
        </ul>
        <div className="datapoints">
          <Datapoint number="200 M+" type="Phone Numbers" />
          <Datapoint number="400 M+" type="Emails" />
          <Datapoint number="99 %" type="Data Accuracy" />
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials">
        <h2>Trusted by Top Sales Teams</h2>
        <div className="testimonial-cards">
          <blockquote className="testimonial">
            “We doubled our demo calls in just two weeks—this tool is a game-changer.”<br/>
            <cite>— Sarah Lee, Sales Director at Acme Corp</cite>
          </blockquote>
          <blockquote className="testimonial">
            “The accuracy is unbelievable. No more bounced emails or dead numbers.”<br/>
            <cite>— Jason Wang, Head of Growth at Orion Tech</cite>
          </blockquote>
        </div>
      </section>

      {/* PRICING TEASER */}
      <section className="pricing-teaser">
        <h2>Simple, Transparent Pricing</h2>
        <p>Plans start at just <strong>$24/month</strong>—no hidden fees or per-seat add-ons. Scale as you grow.</p>
        <Link to="/pricing"><button className="btn-secondary">
          View Plans & Features
        </button></Link>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>Ready to Supercharge Your Pipeline?</h2>
        <Link to="/signup"><button className="btn-primary">
          Get Started Free
        </button></Link>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
